import { Heart, Target, Eye } from "lucide-react";

export const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white" data-testid="about-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="about-title"
          >
            About Our Ministry
          </h2>
          <div className="w-24 h-1 bg-amber-600 mx-auto mb-3"></div>
          <p className="text-amber-700 text-sm font-semibold" style={{ fontFamily: "'Crimson Text', serif" }}>
            Registered Non-Profit Organization • CAC/IT/NO 8553783
          </p>
        </div>

        {/* Mission & Vision Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          {/* Mission Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow" data-testid="mission-card">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center">
                <Target className="text-white" size={32} />
              </div>
              <h3
                className="text-3xl font-bold text-gray-900"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Our Mission
              </h3>
            </div>
            <p
              className="text-gray-700 leading-relaxed text-base"
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              To spread the Gospel of Jesus Christ and bring salvation to souls worldwide. We are dedicated to empowering believers, serving communities, and demonstrating God's love through practical ministry and spiritual guidance. Our mission is to be a beacon of hope and light in a world that desperately needs the transformative power of Christ.
            </p>
          </div>

          {/* Vision Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow" data-testid="vision-card">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center">
                <Eye className="text-white" size={32} />
              </div>
              <h3
                className="text-3xl font-bold text-gray-900"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Our Vision
              </h3>
            </div>
            <p
              className="text-gray-700 leading-relaxed text-base"
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              To build a global community of Spirit-filled believers who are equipped to impact their world for Christ. We envision thriving local churches, transformed communities, and generations of faithful disciples who carry the banner of God's grace to every nation, tribe, and tongue.
            </p>
          </div>
        </div>

        {/* Values Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 max-w-5xl mx-auto" data-testid="values-section">
          <div className="text-center mb-8">
            <h3
              className="text-3xl font-bold text-gray-900 mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Our Core Values
            </h3>
            <div className="w-20 h-1 bg-amber-600 mx-auto"></div>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center" data-testid="value-faith">
              <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="text-gray-700" size={28} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>Faith</h4>
              <p className="text-gray-600 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>Trusting in God's promises</p>
            </div>
            
            <div className="text-center" data-testid="value-love">
              <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="text-gray-700" size={28} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>Love</h4>
              <p className="text-gray-600 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>Showing Christ's compassion</p>
            </div>
            
            <div className="text-center" data-testid="value-service">
              <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="text-gray-700" size={28} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>Service</h4>
              <p className="text-gray-600 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>Serving with humility</p>
            </div>
            
            <div className="text-center" data-testid="value-integrity">
              <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="text-gray-700" size={28} />
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>Integrity</h4>
              <p className="text-gray-600 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>Walking in righteousness</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};